import { IconArrowNarrowDown } from '@tabler/icons-react';
import type { SortOrder } from 'antd/es/table/interface';
import classNames from 'classnames';
import { useFela } from 'react-fela';

import { sortIconClassNames } from './constants';
import * as felaRules from './SortIcon.rules';

export interface SortIconProps {
    sortOrder?: SortOrder;
}

export const SortIcon = ({ sortOrder }: SortIconProps) => {
    const { css } = useFela({ sortOrder });

    return (
        <IconArrowNarrowDown
            className={classNames(sortIconClassNames.sortIcon, sortOrder && sortIconClassNames.sortIconActive, css(felaRules.sortIcon))}
        />
    );
};
